import "./MessageForm.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import React from "react";
import emailjs from "@emailjs/browser";

import { init } from "@emailjs/browser";
init("user_4Jt9LaL1hAL2ezLYrSRXG");

export default class MessageForm extends React.Component {
  state = {
    isNameCorrect: true,
    isEmailCorrect: true,
    isMessageCorrect: true,
  };

  updateInput = (e) => {
    // console.log(e.target.name);
    const inputName = e.target.name;
    // console.log(
    //   inputName[0].toUpperCase() + inputName.slice(1, inputName.length)
    // );
    this.setState({
      [`is${
        inputName[0].toUpperCase() + inputName.slice(1, inputName.length)
      }Correct`]: true,
    });
  };

  submitMessage = (e) => {
    e.preventDefault();
    const name = e.target.name.value;
    const email = e.target.email.value;
    const message = e.target.message.value;

    if (!name || !email || !message) {
      this.setState({
        isNameCorrect: !name ? false : true,
        isEmailCorrect: !email ? false : true,
        isMessageCorrect: !message ? false : true,
      });
      return;
    }

    const templateParams = {
      from_name: name,
      message: message,
      from_email: email,
    };

    emailjs.send("service_rwzd8ix", "template_ros0pqf", templateParams).then(
      (response) => {
        // console.log("SUCCESS!", response.status, response.text);
      },
      (err) => {
        console.log("FAILED...", err);
      }
    );

    e.target.reset();
  };
  render() {
    return (
      <form className="form" onSubmit={this.submitMessage}>
        <input
          type="text"
          className={`form__name ${
            this.state.isNameCorrect ? "" : "form__name--error"
          }`}
          placeholder="Name"
          name="name"
          onChange={this.updateInput}
        />
        <input
          type="text"
          className={`form__email ${
            this.state.isEmailCorrect ? "" : "form__email--error"
          }`}
          placeholder="Email"
          name="email"
          onChange={this.updateInput}
        />
        <textarea
          type="text"
          className={`form__message ${
            this.state.isMessageCorrect ? "" : "form__message--error"
          }`}
          placeholder="Message"
          name="message"
          onChange={this.updateInput}
        />
        <button type="submit" className="form__button">
          Send
          <FontAwesomeIcon
            icon={faPaperPlane}
            className="contact__icon--plane"
          />
        </button>
      </form>
    );
  }
}
